let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8FEj1")).then(() => parcelRequire('5NWY1'));